<template>
<div id="admin-homepage">
  <v-container fluid grid-list-xl>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm8 md6 lg5>
        <v-card color="grey lighten-2">
          <v-container>
            <v-btn @click="$router.push('/admin/about')" dark>About</v-btn>
            <v-btn @click="$router.push('/admin/design')" dark>Design</v-btn>
            <v-btn @click="$router.push('/admin/project')" dark>Project</v-btn>
            <v-btn @click="$router.push('/admin/experience')" dark>Experience</v-btn>
            <v-btn @click="$router.push('/admin/completed-dev')" dark>Completed Development</v-btn>
            <v-btn @click="$router.push('/admin/slider-images')" dark>Slider Images</v-btn>
            <v-btn @click="$router.push('/admin/image-gallery')" dark>Image Gallery</v-btn>
            <v-btn @click="$router.push('/admin/company-contact')" dark>Company Contact</v-btn>
            <v-btn @click="$router.push('/admin/social-links')" dark>Social Links</v-btn>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  beforeMount () {
    if (!this.loginStatus) {
      this.$router.push('/admin/login')
    }
  },
  watch: {
    loginStatus: function () {
      if (!this.loginStatus) {
        this.$router.push('/admin/login')
      }
    }
  },
  computed: {
    ...mapGetters({
      loginStatus: 'adminUser/getLoginStatus'
    })
  },
  methods: {
    ...mapActions({
      logout: 'adminUser/logout'
    })
  }
}
</script>

<style scoped>
#login-page {
  font-family: 'Lato', sans-serif;
  font-size: 1.2vmax;
}
#slogan {
  font-size: 2vmax;
  font-family: 'Vollkorn', serif;
}
#page-name {
  font-size: 3.5vmax;
  font-family: 'Vollkorn', serif;
}
.page-subheading {
  font-size: 2vmax;
}
</style>


// WEBPACK FOOTER //
// src/admin_pages/AdminHomePage.vue